import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CardLoader from "../loader/CardLoader";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { toast } from 'react-toastify';
import { phonesNumberCountries } from "../config/constant";
import { handleSearchAdresses, handleChangeSearchedAdress, handleChangeStringField, handleCheckBooleanFields} from "../functions/reactFieldChange";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { IFieldAdresse, IClientAnnuaire, IClientAnnuaireFields, selectOption, updateAnnuaireProps, IClientAnnuaireData, IClientsAnnuaireInfoComplementaire } from "../type/type";
import { useQuery, useMutation } from "react-query";
import config from "../config/config";
import axios from "axios";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fr } from "date-fns/locale";

const Annuaire = () => 
{
    const logo = require("../assets/img/logo.png")
    const [updateSucceed, setUpdateSucceed] = useState<boolean>(false)
    const { id } = useParams()
    const [ loading, setLoading ] = useState<boolean>(true)
    const [defaultValueInfoComplementaire, setDefaultValueInfoComplementaire]   = useState<selectOption[]>([])
    const {data: clientAnnuaire } = useQuery<IClientAnnuaire>
    (
        "clientAnnuaire"
        ,async () => 
        {
            return await axios.get(`${config.backUrl}`, 
            {
                params : 
                {
                    controller: "annuaire",
                    id : id
                }
            }).then(response => 
            {
                setLoading(false)
                return response.data
            })
            .catch((error) => 
            {
                setLoading(false)
                if (error.response) 
                {
                    console.error(error.response.data.detail)
                } else if (error.request) 
                {
                    console.error(error.request)
                } else {
                    console.error(error.message)
                }
            })
        },
        {
            enabled : loading
        }
    )
    const [adresseSelected, setAdresseSelected] = useState<IFieldAdresse>({
        label: '',
        name: '',
        postcode: '',
        city: ''
    })
    const [fields, setFields] = useState<IClientAnnuaireFields>({
        nom: ""
        ,prenom: ""
        ,tel: ""
        ,portable: ""
        ,fax: ""
        ,adresse: ""
        ,adresse2: ""
        ,eMail: ""
        ,codePostal: ""
        ,ville: ""
        ,casepalais: ""
        ,commissaireCompte: false
        ,infoComplementaire: []
        ,sermentDate: null
        ,specialite : ""
    })

    const {data: languesData } = useQuery<IClientsAnnuaireInfoComplementaire[]>(
        'infoComplementaireLangues'
        ,async () => await axios.get(`${config.backUrl}`,
        {
            params : 
            {
                controller: "annuaireLangue"
            }
        }).then(response => response.data))
        
    const {data: specialitesData } = useQuery<IClientsAnnuaireInfoComplementaire[]>(
        'infoComplementaireSpecialites'
        ,async () => await axios.get(`${config.backUrl}`,
        {
            params : 
            {
                controller: "annuaireSpecialite"
            }
        }).then(response => response.data))
    
    const langues: IClientsAnnuaireInfoComplementaire[] = languesData ?? []
    const specialites: IClientsAnnuaireInfoComplementaire[] = specialitesData ?? []
    const infoComplementaire = (clientAnnuaire?.client.clientActivite?.codeActivite.toLowerCase() === "td") ? langues : specialites;
    const optionsInfoComplementaire: selectOption[] = infoComplementaire.map((item) => 
    { 
        return { label: item.label, value : item.label} as selectOption;
    });
    
    const mutationAnnuaire = useMutation(
        async ({fields, id} : updateAnnuaireProps) => 
        {
            let data = {
                ...fields,
                id: id,
                controller: "annuaire",
                action: "patch",
                formType : "annuaire"
            } as IClientAnnuaireData;
            if(data.sermentDate != null)
            {
                data.dateSerment =  data.sermentDate.toLocaleDateString("fr")
                delete data.sermentDate
            }
            return axios.post(config.backUrl, data, {
                headers : {
                    "Content-Type" : "application/x-www-form-urlencoded"
                }
            })
        },
    )
    const handleSaveData = (id : number) => 
    {
        const toastAnnuaire = toast.loading("Enregistrement en cours ...",
        {
            type: "success",
            position: "bottom-left",
            draggable: false,
            progress: 0,
            theme: "light"
        })
        mutationAnnuaire.mutateAsync({fields : fields, id: id } , 
        {
            onSuccess: () => 
            {
                setUpdateSucceed(true)
                setTimeout(() => { toast.dismiss(toastAnnuaire) }, 5000)
            },
            onError: (error: any) => 
            {
                let errorMessage;
                if (error.response && error.response.data && error.response.data.errors) 
                {
                    const errors = error.response.data.errors;
                    const flatObject = Object.keys(errors).reduce((result: { [key: string]: string }, key) => {
                        const formattedKey = key.charAt(0).toLowerCase() + key.slice(1); // Première lettre en minuscule
                        result[formattedKey] = errors[key][0]; // Prendre le premier message d'erreur pour chaque champ
                        return result;
                    }, {});
                    errorMessage = Object.values(flatObject).join("<br />");
                }else if(error.response && error.response.data && error.response.data.error)
                {
                    errorMessage = error.response.data.error;
                } else {
                    errorMessage = error.message;
                }

                toast.update(toastAnnuaire, 
                {
                    isLoading: false,
                    hideProgressBar: true,
                    type: "error",
                    render: <div dangerouslySetInnerHTML={{ __html: `Erreur lors de l'enregistrement : <br /> ${errorMessage}<br /> veuillez contacter l'administrateur SVP!` }} />
                })
                setTimeout(() => { toast.dismiss(toastAnnuaire) }, 5000);
            }
        })
    }
    useEffect(() => 
    {
        setFields({
            nom: clientAnnuaire?.client.nom ?? ""
            ,prenom: clientAnnuaire?.client.prenoms ?? ""
            ,tel: clientAnnuaire?.client.telFixe ?? ""
            ,fax: clientAnnuaire?.client.fax ?? ""
            ,adresse: clientAnnuaire?.client.adresse ?? ""
            ,adresse2: clientAnnuaire?.client.adresseComplement ?? ""
            ,eMail: clientAnnuaire?.client.email ?? ""
            ,codePostal: clientAnnuaire?.client.codePostal ?? ""
            ,ville: clientAnnuaire?.client.ville ?? ""
            ,infoComplementaire: clientAnnuaire?.client.infoComplementaire ?? []
            ,commissaireCompte: clientAnnuaire?.client.commissaireCompte ?? false
            ,portable: clientAnnuaire?.client.telMobile ?? ""
            ,casepalais: clientAnnuaire?.client.caseAvocat ?? ""
            ,sermentDate: (clientAnnuaire !== undefined && clientAnnuaire.client.dateSerment !== undefined &&  clientAnnuaire.client.dateSerment !== null) ? new Date(clientAnnuaire.client.dateSerment) : null
            ,specialite: clientAnnuaire?.client.specialite ?? ""
        })
        if(clientAnnuaire !== undefined && clientAnnuaire.client.infoComplementaire !== null
                     && clientAnnuaire.client.infoComplementaire.length > 0)
        {
            const defaultValue: selectOption[] = clientAnnuaire.client.infoComplementaire.map((item) => 
            { 
                return { label: item, value : item }
            })
            setDefaultValueInfoComplementaire(defaultValue)
        }
    
    }, [ clientAnnuaire])
    useEffect(() => 
    {    
        if (adresseSelected.label) 
        {
            setFields(fields => ({
                ...fields,
                adresse: adresseSelected.name,
                codePostal: adresseSelected.postcode,
                ville: adresseSelected.city
            }));
        }
    }, [adresseSelected])
    return (
        <div className='container-fluid'>
              <div className="row d-flex justify-content-center">
                  <div className="col-3">
                      <header className='d-flex justify-content-center my-4'>
                          <img src={logo} alt="Tribune Bulletin Côte d'Azur" title="Tribune Bulletin Côte d'Azur" className="img-fluid" />
                      </header>
                  </div>
              </div>
              <div className="row d-flex justify-content-center">
                <div className='col-8'>
                    {loading ? (
                            <div className="card mt-4 shadow">
                                <div className="card-body">
                                    <CardLoader />
                                </div>
                            </div>
                        ) : (
                            <>
                                {updateSucceed ? 
                                (
                                    <div className="alert alert-success shadow p-3 fw-bolder" role="alert" style={{ borderColor: "#155724"}}>
                                        La mise à jour des données a été prise en compte
                                    </div>
                                ) : (
                                    <div className="card mt-4 shadow">
                                        <div className="card-header fw-bold fs-4">
                                            Mise à jour des données 
                                            {clientAnnuaire?.id
                                                &&
                                                (
                                                    <h4 className="card-subtitle fw-normal fs-5 my-1 text-muted">Rubrique : {clientAnnuaire.client.clientActivite?.libelle} </h4>
                                                )
                                            }
                                        </div>
                                        <div className="card-body py-4">
                                            {(clientAnnuaire !== undefined && clientAnnuaire.id !== undefined) ? 
                                                (
                                                    <>
                                                        <div className="row my-3">
                                                            <div className="col">
                                                                <label htmlFor="nom" className="form-label">Nom</label>
                                                                <input type="text" 
                                                                    className="form-control" 
                                                                    name="nom"
                                                                    value={fields.nom} 
                                                                    onChange={(e) => {
                                                                            handleChangeStringField(e, fields, setFields)
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <label htmlFor="prenom" className="form-label">Prénom</label>
                                                                <input type="text" className="form-control" 
                                                                    value={fields.prenom} 
                                                                    name="prenom"
                                                                    onChange={(e) => {
                                                                        handleChangeStringField(e, fields, setFields)
                                                                    }} 
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col">
                                                                <label htmlFor="eMail" className="form-label">E-mail</label>
                                                                <input type="text" className="form-control" 
                                                                        value={fields.eMail} 
                                                                        name="eMail"
                                                                        onChange={(e) => {
                                                                            handleChangeStringField(e, fields, setFields)
                                                                    }} />
                                                            </div>
                                                            <div className="col">
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <label htmlFor="tel" className="form-label">Téléphone</label>
                                                                        <PhoneInput
                                                                            name='tel'
                                                                            value={fields.tel}
                                                                            onChange={(value) =>{ 
                                                                                setFields({ ...fields, tel: value ?? ""})
                                                                            }}
                                                                            displayInitialValueAsLocalNumber
                                                                            defaultCountry="FR"
                                                                            autoComplete={'new-' + fields.tel}
                                                                            countries={phonesNumberCountries}
                                                                        />
                                                                    </div>
                                                                    {(clientAnnuaire?.client.clientActivite?.codeActivite
                                                                            && ["av", "ej", "td", "ec", "hu", "no"].includes(clientAnnuaire?.client.clientActivite?.codeActivite.toLowerCase()))
                                                                        &&
                                                                        (
                                                                            <div className="col">
                                                                                <label htmlFor="portable" className="form-label">Portable</label>
                                                                                <PhoneInput
                                                                                    name='portable'
                                                                                    value={fields.portable}
                                                                                    onChange={(value) => {
                                                                                        setFields({ ...fields, portable: value ?? "" })
                                                                                    }}
                                                                                    displayInitialValueAsLocalNumber
                                                                                    defaultCountry="FR"
                                                                                    autoComplete={'new-' + fields.portable}
                                                                                    countries={phonesNumberCountries}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col">
                                                                <label htmlFor="adresse" className="form-label">Adresse</label>
                                                                <AsyncSelect
                                                                    placeholder="Rechercher adresse..."
                                                                    className="basic-single"
                                                                    id='selectAdresse'
                                                                    name="searchAdresse"
                                                                    noOptionsMessage={() => "Aucune adresse correspondante"}
                                                                    isClearable={true}
                                                                    loadingMessage={() => "Recherche en cours..."}
                                                                    loadOptions={handleSearchAdresses} 
                                                                    onChange={(selectedOption) => handleChangeSearchedAdress(selectedOption, setAdresseSelected)}
                                                                />
                                                                <input type="text" className="form-control mt-1" value={fields.adresse} name="adresse" 
                                                                    onChange={(e) => {
                                                                        handleChangeStringField(e, fields, setFields)
                                                                    }} />
                                                            </div>
                                                            <div className="col">
                                                                <div className="row">
                                                                    <div className="col">
                                                                        <label htmlFor="codePostal" className="form-label">Code postal</label>
                                                                        <input type="text" className="form-control" 
                                                                            value={fields.codePostal} 
                                                                            name="codePostal"
                                                                            onChange={(e) => {
                                                                                handleChangeStringField(e, fields, setFields)
                                                                        }} />
                                                                    </div>
                                                                    <div className="col">
                                                                        <label htmlFor="ville" className="form-label">Ville</label>
                                                                        <input type="text" className="form-control" 
                                                                            value={fields.ville}
                                                                            name="ville"
                                                                            onChange={(e) => {
                                                                                handleChangeStringField(e, fields, setFields)
                                                                        }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row my-3">
                                                            <div className="col">
                                                                <label htmlFor="adresse2" className="form-label">Complément d'adresse (optionnel)</label>
                                                                <input type="text" className="form-control" 
                                                                        value={fields.adresse2} 
                                                                        name="adresse2"
                                                                        onChange={(e) => {
                                                                            handleChangeStringField(e, fields, setFields)
                                                                    }} />
                                                            </div>
                                                            <div className="col">
                                                                <label htmlFor="fax" className="form-label">Fax</label>
                                                                <PhoneInput
                                                                    name='fax'
                                                                    value={fields.fax}
                                                                    onChange={(value) => {
                                                                        setFields({ ...fields, fax: value ?? "" })
                                                                    }}
                                                                    displayInitialValueAsLocalNumber
                                                                    defaultCountry="FR"
                                                                    autoComplete={'new-' + fields.fax}
                                                                    countries={phonesNumberCountries}
                                                                />
                                                            </div>
                                                        </div>
                                                        {(clientAnnuaire?.client.clientActivite?.codeActivite
                                                            && ["ec", "se", "cc"].includes(clientAnnuaire?.client.clientActivite?.codeActivite.toLowerCase()))
                                                        &&
                                                        (
                                                            <div className="row my-3">
                                                                <div className="col">
                                                                    <div className="form-check">
                                                                        <input className="form-check-input" type="checkbox" 
                                                                            name="commissaireCompte"
                                                                            checked={fields.commissaireCompte}
                                                                            id="commissaireCompte"
                                                                            onChange={(e) => handleCheckBooleanFields(e, fields, setFields)} 
                                                                        />
                                                                        <label className="form-check-label" htmlFor="commissaireCompte">
                                                                            Commissaire aux comptes
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(clientAnnuaire?.client.clientActivite?.codeActivite
                                                            && ["ej", "td"].includes(clientAnnuaire?.client.clientActivite?.codeActivite.toLowerCase()))
                                                            &&
                                                            (
                                                                <div className="row my-3">
                                                                    <div className="col-6">
                                                                        <label htmlFor="infoComplementaire" className="col-form-label">
                                                                            { clientAnnuaire?.client.clientActivite?.codeActivite.toLowerCase() === "td" ? "Langues" : "Spécialités" }
                                                                        </label>
                                                                        <Select
                                                                            placeholder=""
                                                                            isClearable={true}
                                                                            isSearchable={true}
                                                                            options={optionsInfoComplementaire}
                                                                            isMulti={true}
                                                                            defaultValue={defaultValueInfoComplementaire}
                                                                            value={fields.infoComplementaire?.map((item) => 
                                                                                { 
                                                                                    return { label: item, value : item }
                                                                                })
                                                                            }
                                                                            onChange={(selectedOption) => 
                                                                            {
                                                                                setFields({...fields, "infoComplementaire": selectedOption.map(item => item.value) }) 
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {(clientAnnuaire?.client.clientActivite?.codeActivite
                                                            && ["av"].includes(clientAnnuaire?.client.clientActivite?.codeActivite.toLowerCase()))
                                                            &&
                                                            (
                                                                <>
                                                                    <div className="row my-3">
                                                                        <div className="col">
                                                                            <label htmlFor="casepalais" className="form-label">Case Palais</label>
                                                                            <input type="text" className="form-control" 
                                                                                    value={fields.casepalais} 
                                                                                    name="casepalais"
                                                                                    onChange={(e) => {
                                                                                        handleChangeStringField(e, fields, setFields)
                                                                                }} />
                                                                        </div>
                                                                        <div className="col">
                                                                            <label htmlFor="sermentDate" className="form-label">Date de serment</label>
                                                                            <div className="row">
                                                                                <div className="col">
                                                                                    <ReactDatePicker
                                                                                        id='sermentDate'
                                                                                        name='sermentDate'
                                                                                        locale={fr}
                                                                                        className="form-control"
                                                                                        selected={fields.sermentDate ? fields.sermentDate : null}
                                                                                        disabledKeyboardNavigation
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        onKeyDown={(e) => { e.preventDefault() }}
                                                                                        onChange={(date) => { setFields({...fields, "sermentDate": date }) }} 
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row my-3">
                                                                        <div className="col-6">
                                                                            <label htmlFor="specialite" className="col-form-label">Spécialités</label>
                                                                            <input type="text" className="form-control" 
                                                                                value={fields.specialite} 
                                                                                name="specialite"
                                                                                onChange={(e) => {
                                                                                    handleChangeStringField(e, fields, setFields)
                                                                            }} />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        <div className="row my-3 d-flex justify-content-end">
                                                            <div className="col-5 d-flex justify-content-end">
                                                                <button type="button" className="text-uppercase btn btn-primary" onClick={() => handleSaveData(clientAnnuaire.id) }>
                                                                    Enregistrer (Même sans changement)
                                                                </button>
                                                            </div> 
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="alert alert-danger" role="alert">
                                                        Impossible de charger les données, veuillez contacter l'administrateur du site
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                </div>
              </div>
              <div className="row d-flex justify-content-center">
                  <div className="col-10">
                      <footer className='d-flex justify-content-center my-4 text-muted'>
                        &copy; Tribune Côte d'Azur
                      </footer>
                  </div>
              </div>
          </div>
    )
}

export default Annuaire;